import angular from 'angular'

import Authentication           from './authentication'
import Cookies                  from './cookies'
import ErrorPage                from './error'
import Help                     from './help'
import Home                     from './home'
import Installation             from './installation'
import InstallationGuide        from './installation/installation-guide'
import Maintenance              from './maintenance'
import ManagePurchase           from './manage-purchase'
import Profile                  from './profile'
import Registration             from './registration'
import RegistrationConfirmation from './registration-confirmation'
import ResetPassword            from './reset-password'
import Vehicle                  from './vehicle'
import ChangePassword           from './change-password'

let module = angular.module('app.pages', [
  Authentication,
  Cookies,
  ErrorPage,
  Help,
  Home,
  Installation,
  InstallationGuide,
  Maintenance,
  ManagePurchase,
  Profile,
  Registration,
  RegistrationConfirmation,
  ResetPassword,
  Vehicle,
  ChangePassword
])
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/index.js